import request from '@/utils/request'

/**
 * 查询设备质保信息
 * @param {string} snCode 设备SN码
 * @returns {Promise} 包含质保信息的Promise对象
 */
export function searchWarranty(snCode) {
    return request({
        url: `/sale-out-service/asset/searchWarranty/${snCode}`,
        method: 'get',
        // 如果需要额外参数可以在这里添加
        params: {
            // timestamp: new Date().getTime() // 防止缓存
        }
    })
}
